import HttpService from "./HttpService";
const API_ENDPOINT = "/ess-project";

const MyProjectService = {
  async getProjects(pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  // Server-side export. `type` is "excel" | "pdf". Returns the raw axios
  // response (response.data is a Blob).
  async exportList(type) {
    return HttpService.post(
      `${API_ENDPOINT}-export`,
      { type },
      { responseType: "blob", timeout: 0 }
    );
  },
};

export default MyProjectService;
